// extracted by mini-css-extract-plugin
export default {"top":"Footer_top__XfDGF","bottom":"Footer_bottom__J7kjW"};